import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const RECENT_SALES = [{
  name: 'Sofía',
  city: 'Buenos Aires',
  combo: '2'
}, {
  name: 'Camila',
  city: 'Córdoba',
  combo: '3'
}, {
  name: 'Valentina',
  city: 'Rosario',
  combo: '2'
}, {
  name: 'Isabella',
  city: 'Mendoza',
  combo: '1'
}, {
  name: 'Martina',
  city: 'La Plata',
  combo: '2'
}, {
  name: 'Lucía',
  city: 'San Miguel de Tucumán',
  combo: '3'
}, {
  name: 'Mariana',
  city: 'Mar del Plata',
  combo: '2'
}, {
  name: 'Gabriela',
  city: 'Salta',
  combo: '3'
}, {
  name: 'Florencia',
  city: 'Santa Fe',
  combo: '1'
}, {
  name: 'Agustina',
  city: 'San Juan',
  combo: '2'
}, {
  name: 'Carolina',
  city: 'Neuquén',
  combo: '3'
}, {
  name: 'Julieta',
  city: 'Bahía Blanca',
  combo: '2'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState(RECENT_SALES[0]);
  useEffect(() => {
    // Random interval between 6-9 seconds
    const showPopup = () => {
      const randomSale = RECENT_SALES[Math.floor(Math.random() * RECENT_SALES.length)];
      setCurrentSale(randomSale);
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
      }, 4000);
      // Schedule next popup
      const nextInterval = Math.random() * 3000 + 6000; // 6000-9000ms
      timeoutId = setTimeout(showPopup, nextInterval);
    };
    let timeoutId = setTimeout(showPopup, 2000); // First popup after 2s
    return () => clearTimeout(timeoutId);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-[90vw] sm:max-w-sm animate-slide-in-up" data-id="element-147">
      <div className="bg-[#1a1a24] border border-[#d4a853]/30 p-4 rounded-xl shadow-2xl flex items-center gap-3 backdrop-blur-md" data-id="element-148">
        <div className="bg-green-500/10 p-2 rounded-full" data-id="element-149">
          <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-150" />
        </div>
        <div data-id="element-151">
          <p className="text-sm font-medium text-white" data-id="element-152">
            <span className="font-bold text-[#d4a853]" data-id="element-153">{currentSale.name}</span>{' '}
            de {currentSale.city}
          </p>
          <p className="text-xs text-gray-400" data-id="element-154">
            Acaba de comprar el{' '}
            <span className="text-white" data-id="element-155">Combo {currentSale.combo}</span>
          </p>
        </div>
      </div>
    </div>;
}